import { render, staticRenderFns } from "./NsDonationForm.vue?vue&type=template&id=0a95c58e&scoped=true&"
import script from "./NsDonationForm.vue?vue&type=script&lang=js&"
export * from "./NsDonationForm.vue?vue&type=script&lang=js&"
import style0 from "./NsDonationForm.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./NsDonationForm.vue?vue&type=style&index=1&id=0a95c58e&lang=scss&scoped=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsDonationForm.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./NsDonationForm.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("0a95c58e")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0a95c58e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a95c58e')) {
      api.createRecord('0a95c58e', component.options)
    } else {
      api.reload('0a95c58e', component.options)
    }
    module.hot.accept("./NsDonationForm.vue?vue&type=template&id=0a95c58e&scoped=true&", function () {
      api.rerender('0a95c58e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsDonationForm.vue"
export default component.exports